import { useState } from 'react';

import { isRichtextEmpty } from 'approot/shared/richtext/richtext.utils';
import { ClassroomAnswerInstruction } from 'approot/activity-builder/classroom/classroom-answer.style';
import { LinkButton } from 'approot/shared/styles/buttons/link-button.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import type { InteractiveSubActivityFragment } from '../../../lesson-builder.graphql.generated';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import IconInformation from 'approot/shared/icons/icon-information';
import { Box } from 'approot/shared/design-system/box/box.style';
import SubActivityView from '../../sub-activity/sub-activity-view';
import * as Styled from './draw-canvas-instruction.style';
import { INSTRUCTION_ELEMENT_ID } from './draw-canvas.constants';

type Props = {
  id: string;
  type: string;
  subActivityProperties?: InteractiveSubActivityFragment | null;
};

const DrawCanvasInstruction = ({ id, type, subActivityProperties }: Props) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  const hasInstructions =
    subActivityProperties &&
    !isRichtextEmpty(subActivityProperties.instructions);

  return (
    hasInstructions && (
      <Styled.DrawActivityInstruction
        id={INSTRUCTION_ELEMENT_ID}
        $isVisible={isVisible}
      >
        {isVisible ? (
          <Styled.DrawActivityInstructionInner>
            {isVisible && (
              <ClassroomAnswerInstruction $noMarginBottom>
                <SubActivityView
                  withTTSButton
                  componentId={id}
                  componentType={type}
                  subActivityDetails={subActivityProperties}
                />
              </ClassroomAnswerInstruction>
            )}
            <Box $gap={8} $alignItems="center" $marginTop={isVisible ? 8 : 0}>
              <LinkButton
                type="button"
                onClick={() => setIsVisible(!isVisible)}
              >
                Hide Instruction
              </LinkButton>
            </Box>
          </Styled.DrawActivityInstructionInner>
        ) : (
          <TooltipWrapper hoverText="Show Instruction">
            <SecondaryButtonIcon
              type="button"
              aria-label="Show Instruction"
              $borderRadius={40}
              onClick={() => setIsVisible(!isVisible)}
            >
              <IconInformation width={22} height={22} />
            </SecondaryButtonIcon>
          </TooltipWrapper>
        )}
      </Styled.DrawActivityInstruction>
    )
  );
};

export default DrawCanvasInstruction;
